function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, computed, runInAction, makeObservable, override } from "mobx";
import binarySearch from "terriajs-cesium/Source/Core/binarySearch";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import getChartColorForId from "../Charts/getChartColorForId";
import filterOutUndefined from "../Core/filterOutUndefined";
import isDefined from "../Core/isDefined";
import TerriaError from "../Core/TerriaError";
import ChartableMixin, { calculateDomain } from "../ModelMixins/ChartableMixin";
import CommonStrata from "../Models/Definition/CommonStrata";
import { DATE_SECONDS_PRECISION } from "./TimeVarying";
function DiscretelyTimeVaryingMixin(Base) {
  var _dec, _dec2, _dec3, _dec4, _dec5, _class;
  let DiscretelyTimeVaryingMixin = (_dec = computed({
    equals: JulianDate.equals
  }), _dec2 = computed({
    equals: JulianDate.equals
  }), _dec3 = computed({
    equals: JulianDate.equals
  }), _dec4 = computed({
    equals: JulianDate.equals
  }), _dec5 = computed({
    equals: JulianDate.equals
  }), _class = class DiscretelyTimeVaryingMixin extends ChartableMixin(Base) {
    constructor() {
      super(...arguments);
      makeObservable(this);
    }
    get hasDiscreteTimes() {
      return true;
    }
    get currentTime() {
      const time = super.currentTime;
      if (time === undefined || time === null) {
        if (this.initialTimeSource === "now") {
          return JulianDate.toIso8601(JulianDate.now(), DATE_SECONDS_PRECISION);
        } else if (this.initialTimeSource === "start") {
          return this.startTime;
        } else if (this.initialTimeSource === "stop") {
          return this.stopTime;
        } else if (this.initialTimeSource === "none") {
          return undefined;
        } else {
          throw new TerriaError({
            sender: this,
            title: "Invalid initialTime value",
            message: "The `initialTime` property has an invalid value: `" + this.initialTimeSource + "`."
          });
        }
      }
      return time;
    }
    get currentTimeAsJulianDate() {
      return toJulianDate(this.currentTime);
    }
    get startTimeAsJulianDate() {
      return toJulianDate(this.startTime);
    }
    get stopTimeAsJulianDate() {
      return toJulianDate(this.stopTime);
    }
    get objectifiedDates() {
      if (!isDefined(this.discreteTimesAsSortedJulianDates)) {
        return {
          index: [],
          dates: []
        };
      }
      const jsDates = this.discreteTimesAsSortedJulianDates.map(julianDate => JulianDate.toDate(julianDate.time));
      return objectifyDates(jsDates);
    }
    get discreteTimesAsSortedJulianDates() {
      const discreteTimes = this.discreteTimes;
      if (discreteTimes === undefined) {
        return undefined;
      }
      const asJulian = [];
      for (let i = 0; i < discreteTimes.length; i++) {
        const dt = discreteTimes[i];
        try {
          if (dt.time !== undefined) {
            const time = JulianDate.fromIso8601(dt.time);
            asJulian.push({
              time,
              tag: dt.tag !== undefined ? dt.tag : dt.time
            });
          }
        } catch (_unused) {}
      }
      asJulian.sort((a, b) => JulianDate.compare(a.time, b.time));
      return asJulian;
    }
    getDiscreteTimeIndex(time) {
      const discreteTimes = this.discreteTimesAsSortedJulianDates;
      if (discreteTimes === undefined || discreteTimes.length === 0) {
        return undefined;
      }

      // Where does `time` fit in our sequence of discrete times?
      const exactIndex = binarySearch(discreteTimes, time, (candidate, currentTime) => JulianDate.compare(candidate.time, currentTime));
      // We have this exact time in our discrete times
      if (exactIndex >= 0) {
        return exactIndex;
      }

      // This is where `time` could be inserted into the discrete times list so that they're all in sorted order
      const nextIndex = ~exactIndex;
      if (nextIndex === 0 || this.fromContinuous === "next") {
        // Before the first, or we want the next time no matter which is closest
        return nextIndex;
      } else if (nextIndex === discreteTimes.length || this.fromContinuous === "previous") {
        // After the last, or we want the previous time no matter which is closest
        return nextIndex - 1;
      } else {
        // Get the closest discrete time
        const previousTime = discreteTimes[nextIndex - 1].time;
        const nextTime = discreteTimes[nextIndex].time;
        const timeFromPrevious = JulianDate.secondsDifference(time, previousTime);
        const timeToNext = JulianDate.secondsDifference(nextTime, time);
        if (timeToNext > timeFromPrevious) {
          return nextIndex - 1;
        } else {
          return nextIndex;
        }
      }
    }
    get currentDiscreteTimeIndex() {
      return this.currentTimeAsJulianDate && this.getDiscreteTimeIndex(this.currentTimeAsJulianDate);
    }
    get nextDiscreteTimeIndex() {
      const index = this.currentDiscreteTimeIndex;
      if (index === undefined || index === this.discreteTimesAsSortedJulianDates.length - 1) {
        return undefined;
      }
      return index + 1;
    }
    get previousDiscreteTimeIndex() {
      const index = this.currentDiscreteTimeIndex;
      if (index === undefined || index === 0) {
        return undefined;
      }
      return index - 1;
    }
    get currentDiscreteJulianDate() {
      const index = this.currentDiscreteTimeIndex;
      return index === undefined ? undefined : this.discreteTimesAsSortedJulianDates[index].time;
    }
    get nextDiscreteJulianDate() {
      const index = this.nextDiscreteTimeIndex;
      return index === undefined ? undefined : this.discreteTimesAsSortedJulianDates[index].time;
    }
    get currentDiscreteTimeTag() {
      const index = this.currentDiscreteTimeIndex;
      return index === undefined ? undefined : this.discreteTimesAsSortedJulianDates[index].tag;
    }
    get previousDiscreteTimeTag() {
      const index = this.previousDiscreteTimeIndex;
      return index === undefined ? undefined : this.discreteTimesAsSortedJulianDates[index].tag;
    }
    get nextDiscreteTimeTag() {
      const index = this.nextDiscreteTimeIndex;
      return index === undefined ? undefined : this.discreteTimesAsSortedJulianDates[index].tag;
    }
    get isPreviousDiscreteTimeAvailable() {
      return this.previousDiscreteTimeIndex !== undefined;
    }
    get isNextDiscreteTimeAvailable() {
      return this.nextDiscreteTimeIndex !== undefined;
    }
    get startTime() {
      const time = super.startTime;
      if (time === undefined && this.discreteTimesAsSortedJulianDates && this.discreteTimesAsSortedJulianDates.length > 0) {
        return JulianDate.toIso8601(this.discreteTimesAsSortedJulianDates[0].time, DATE_SECONDS_PRECISION);
      }
      return time;
    }
    get stopTime() {
      const time = super.stopTime;
      if (time === undefined && this.discreteTimesAsSortedJulianDates && this.discreteTimesAsSortedJulianDates.length > 0) {
        return JulianDate.toIso8601(this.discreteTimesAsSortedJulianDates[this.discreteTimesAsSortedJulianDates.length - 1].time, DATE_SECONDS_PRECISION);
      }
      return time;
    }

    /**
     * Try to calculate a multiplier which results in a new time step every {this.multiplierDefaultDeltaStep} seconds. For example, if {this.multiplierDefaultDeltaStep = 5} it would set the `multiplier` so that a new time step (of this dataset) would appear every five seconds (on average) if the timeline is playing.
     */
    get multiplier() {
      if (super.multiplier) return super.multiplier;
      if (!isDefined(this.startTimeAsJulianDate) || !isDefined(this.stopTimeAsJulianDate) || !isDefined(this.multiplierDefaultDeltaStep) || !isDefined(this.discreteTimesAsSortedJulianDates)) return;
      const dSeconds = (this.stopTimeAsJulianDate.dayNumber - this.startTimeAsJulianDate.dayNumber) * 24 * 60 * 60 + this.stopTimeAsJulianDate.secondsOfDay - this.startTimeAsJulianDate.secondsOfDay;
      const meanDSeconds = dSeconds / this.discreteTimesAsSortedJulianDates.length;
      return meanDSeconds / this.multiplierDefaultDeltaStep;
    }
    moveToPreviousDiscreteTime(stratumId) {
      const index = this.previousDiscreteTimeIndex;
      if (index === undefined) {
        return;
      }
      this.setTrait(stratumId, "currentTime", JulianDate.toIso8601(this.discreteTimesAsSortedJulianDates[index].time, DATE_SECONDS_PRECISION));
    }
    moveToNextDiscreteTime(stratumId) {
      const index = this.nextDiscreteTimeIndex;
      if (index === undefined) {
        return;
      }
      this.setTrait(stratumId, "currentTime", JulianDate.toIso8601(this.discreteTimesAsSortedJulianDates[index].time, DATE_SECONDS_PRECISION));
    }
    get momentChart() {
      if (!this.showInChartPanel || !this.discreteTimesAsSortedJulianDates) return;
      const points = this.discreteTimesAsSortedJulianDates.map(dt => ({
        x: JulianDate.toDate(dt.time),
        y: 0.5,
        isSelected: this.currentDiscreteJulianDate && this.currentDiscreteJulianDate.equals(dt.time)
      }));
      const colorId = "color-".concat(this.name);
      return {
        item: this,
        id: this.name || "",
        name: this.name || "",
        categoryName: this.name,
        key: "key".concat(this.uniqueId, "-").concat(this.name),
        type: this.chartType || "momentLines",
        glyphStyle: this.chartGlyphStyle,
        xAxis: {
          name: "Time",
          scale: "time"
        },
        points,
        domain: _objectSpread(_objectSpread({}, calculateDomain(points)), {}, {
          y: [0, 1]
        }),
        showInChartPanel: this.show && this.showInChartPanel,
        isSelectedInWorkbench: this.showInChartPanel,
        updateIsSelectedInWorkbench: isSelected => {
          runInAction(() => {
            this.setTrait(CommonStrata.user, "showInChartPanel", isSelected);
          });
        },
        getColor: () => {
          return this.chartColor ? this.chartColor : getChartColorForId(colorId);
        },
        onClick: point => {
          runInAction(() => {
            this.setTrait(CommonStrata.user, "currentTime", point.x.toISOString());
          });
        }
      };
    }
    get chartItems() {
      return filterOutUndefined([this.momentChart]);
    }
  }, _applyDecoratedDescriptor(_class.prototype, "currentTime", [override], Object.getOwnPropertyDescriptor(_class.prototype, "currentTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTimeAsJulianDate", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "currentTimeAsJulianDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startTimeAsJulianDate", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "startTimeAsJulianDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stopTimeAsJulianDate", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "stopTimeAsJulianDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "objectifiedDates", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "objectifiedDates"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "discreteTimesAsSortedJulianDates", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "discreteTimesAsSortedJulianDates"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentDiscreteTimeIndex", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentDiscreteTimeIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextDiscreteTimeIndex", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "nextDiscreteTimeIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousDiscreteTimeIndex", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "previousDiscreteTimeIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentDiscreteJulianDate", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "currentDiscreteJulianDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextDiscreteJulianDate", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "nextDiscreteJulianDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentDiscreteTimeTag", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentDiscreteTimeTag"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousDiscreteTimeTag", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "previousDiscreteTimeTag"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextDiscreteTimeTag", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "nextDiscreteTimeTag"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPreviousDiscreteTimeAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPreviousDiscreteTimeAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNextDiscreteTimeAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNextDiscreteTimeAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startTime", [override], Object.getOwnPropertyDescriptor(_class.prototype, "startTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stopTime", [override], Object.getOwnPropertyDescriptor(_class.prototype, "stopTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "multiplier", [override], Object.getOwnPropertyDescriptor(_class.prototype, "multiplier"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "moveToPreviousDiscreteTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "moveToPreviousDiscreteTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "moveToNextDiscreteTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "moveToNextDiscreteTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "momentChart", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "momentChart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "chartItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "chartItems"), _class.prototype), _class);
  return DiscretelyTimeVaryingMixin;
}
(function (_DiscretelyTimeVaryingMixin) {
  function isMixedInto(model) {
    return model && model.hasDiscreteTimes;
  }
  _DiscretelyTimeVaryingMixin.isMixedInto = isMixedInto;
})(DiscretelyTimeVaryingMixin || (DiscretelyTimeVaryingMixin = {}));
export default DiscretelyTimeVaryingMixin;
function toJulianDate(time) {
  if (time === undefined || time === null) {
    return undefined;
  }
  // JS's data parser produces some bizarre dates from bad strings without complaint, so we need to do some basic validation
  if (time.includes("NaN")) {
    return undefined;
  }
  const julianDate = JulianDate.fromIso8601(time);

  // Don't return an invalid JulianDate
  if (isNaN(julianDate.secondsOfDay) || isNaN(julianDate.dayNumber)) return undefined;
  return julianDate;
}
/**
 * Process an array of dates into layered objects of years, months and days.
 * @param  {Date[]} An array of dates.
 * @return {Object} Returns an object whose keys are years, whose values are objects whose keys are months (0=Jan),
 *   whose values are objects whose keys are days, whose values are arrays of all the datetimes on that day.
 */
export function objectifyDates(dates) {
  const result = {
    index: [],
    dates
  };
  for (let i = 0; i < dates.length; i++) {
    const date = dates[i];
    const year = date.getFullYear();
    const century = Math.floor(year / 100);
    const month = date.getMonth();
    const day = date.getDate();
    const hour = date.getHours();

    // ObjectifiedDates
    if (!result[century]) {
      result[century] = {
        index: [],
        dates: []
      };
      result.index.push(century);
    }
    result[century].dates.push(date);

    // ObjectifiedYears
    if (!result[century][year]) {
      result[century][year] = {
        index: [],
        dates: []
      };
      result[century].index.push(year);
    }
    result[century][year].dates.push(date);

    // ObjectifiedMonths
    if (!result[century][year][month]) {
      result[century][year][month] = {
        index: [],
        dates: []
      };
      result[century][year].index.push(month);
    }
    result[century][year][month].dates.push(date);

    // ObjectifiedDays
    if (!result[century][year][month][day]) {
      result[century][year][month][day] = {
        index: [],
        dates: []
      };
      result[century][year][month].index.push(day);
    }
    result[century][year][month][day].dates.push(date);

    // ObjectifiedHours
    if (!result[century][year][month][day][hour]) {
      result[century][year][month][day][hour] = [];
      result[century][year][month][day].index.push(hour);
    }
    result[century][year][month][day][hour].push(date);
  }
  return result;
}